import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import cx from 'classnames';
import _ from 'lodash';
import im from 'object-path-immutable';
import { wireValue } from 'ui/hoc/prop-wire';

var log = require('loglevel').getLogger('core/components/form');
/**
 * A React Form Component, with configuration for one or more fields
 * @constructor
 * @param {string} [id] - Container element #id
 * @param {object} fields - All fields definition, in key-config pair
 * @param {object} fields.key - Config for this **key** field
 * @param {renderable} [fields.key.label=key] - Display label
 * @param {string} [fields.key.className] - classname for this field.
 * @param {function} [fields.key.editor] - React class to use for rendering the input
 * @param {object|function} [fields.key.props] - Props for the above react class, see individual doc for the base class
 * @param {renderable|function} [fields.key.formatter] - Render function
 * @param {renderable} [header] - Any react renderable node
 * @param {renderable} [footer] - Any react renderable node
 * @param {string} [className] - Classname for the container
 * @param {string} [fieldClassName] - Global classname for each field
 * @param {object} [defaultValue] - Default form input values
 * @param {object} [value] - Current form input values
 * @param {object} [valueLink] - Link to update value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} valueLink.value - value to update
 * @param {function} valueLink.requestChange - function to request value change
 * @param {function} [onChange] - Callback function when from/to is changed. <br> Required when value prop is supplied
 * @param {object} onChange.value - current form input values
 * @param {object} onChange.eventInfo - event related info
 * @param {object} onChange.eventInfo.before - previous form input values
 *
 * @example
// controlled

import Form from 'core/components/form'
import Input from 'core/components/input'
import DropDownList from 'core/components/dropdown'
import CheckboxGroup from 'core/components/checkbox-group'
import Input from 'core/components/input'
import MultiInput from 'core/components/multi-input'

React.createClass({
    getInitialState() {
        return {
            movie: {
                id: 99,
                year: '1982',
                title: 'Blade Runner',
                directory: 'Ridley Scott',
                languages: ['english','japanese'],
                genre: 'scifi', // index into 'scifi' drop down list
                notes: [],
                scores: {
                    imdb: 8.2,
                    rottenTomatoes: 8.9
                }
            }
        }
    },
    handleChange(movie) {
        this.setState({movie})
    },
    render() {
        let {movie} = this.state;
        return <Form id='movie'
            className='pure-form-aligned'
            fieldClassName='pure-control-group'
            header='Create New Movie'
            fields={{
                id: {label:'ID', formatter:id=>`X${id}`},
                year: {label:'Year', editor:Input, props:{type:'integer', required:true, validate:{min:1900}}},
                title: {label:'Title', editor:Input, props:{required:true}},
                director: {label:'Director', editor:Input, props:{required:true}},
                languages: {label:'Languages', editor:CheckboxGroup, props:{
                    list:[
                        {value:'english',text:'English'},
                        {value:'japanese',text:'Japanese'},
                        {value:'german',text:'German'},
                        {value:'xyz',text:'XYZ'}
                    ],
                    disabled:['xyz']
                }},
                genre: {label:'Genre', editor:DropDownList, props:{
                    list:[
                        {value:'drama', text:'Drama'},
                        {value:'horror', text:'Horror'},
                        {value:'scifi', text:'Sci-Fi'}
                    ],
                    defaultText:'Please select a genre'
                }},
                notes: {label:'Notes', editor:MultiInput, props:{base:Input, inline:true}},
                'scores.imdb': {label:'IMDB Score', editor:Input, props:(data)=>{
                    // disable IMDB score when production year is in the future
                    if (data.year >= 2017) {
                        return {disabled:true}
                    }
                    else {
                        return {type:'number', validate:{min:0}}}
                    }
                },
                'scores.rottenTomatoes': {label:'Rotten Tomatotes Score', editor:Input, props:{type:'number', validate:{min:0}}}
            }}
            onChange={this.handleChange}
            value={movie}/>
    }
})
 */


var Form = createReactClass({
  displayName: "Form",
  propTypes: {
    id: PropTypes.string,
    fields: PropTypes.objectOf(PropTypes.shape({
      label: PropTypes.node,
      className: PropTypes.string,
      formatter: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
      editor: PropTypes.func,
      // react class
      props: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
    })).isRequired,
    header: PropTypes.node,
    footer: PropTypes.node,
    className: PropTypes.string,
    fieldClassName: PropTypes.string,
    value: PropTypes.object,
    // might not be just a simple object
    onChange: PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      value: {}
    };
  },
  handleChange: function handleChange(key, iValue) {
    var _this$props = this.props,
        onChange = _this$props.onChange,
        value = _this$props.value;
    onChange(im.set(value, key, iValue));
  },
  renderField: function renderField(id, value, fieldCfg, dataSet) {
    var formatter = fieldCfg.formatter,
        editor = fieldCfg.editor,
        _fieldCfg$props = fieldCfg.props,
        props = _fieldCfg$props === void 0 ? {} : _fieldCfg$props;

    if (formatter) {
      if (_.isFunction(formatter)) {
        return formatter(value, dataSet);
      } else {
        return formatter;
      }
    } else if (editor) {
      if (_.isFunction(props)) {
        props = props(dataSet);
      } // TODO: check editor must be ReactClass


      props = _objectSpread(_objectSpread({}, props), {}, {
        id: id,
        value: value,
        onChange: this.handleChange.bind(this, id)
      });
      return /*#__PURE__*/React.createElement(editor, props);
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "pre"
      }, value);
    }
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        id = _this$props2.id,
        fields = _this$props2.fields,
        value = _this$props2.value,
        header = _this$props2.header,
        footer = _this$props2.footer,
        className = _this$props2.className,
        fieldClassName = _this$props2.fieldClassName;
    return /*#__PURE__*/React.createElement("div", {
      id: id,
      className: className
    }, header ? /*#__PURE__*/React.createElement("header", null, header) : null, /*#__PURE__*/React.createElement("div", {
      className: "content c-align"
    }, _.map(fields, function (field, key) {
      var _field$label = field.label,
          label = _field$label === void 0 ? key : _field$label,
          _field$className = field.className,
          fieldCls = _field$className === void 0 ? fieldClassName : _field$className;

      var iValue = _.get(value, key, null); // to support traverse of nested field properties, eg a.b.c


      return /*#__PURE__*/React.createElement("div", {
        key: key,
        className: cx(key, fieldCls)
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: key
      }, label), _this.renderField(key, iValue, field, value));
    })), footer ? /*#__PURE__*/React.createElement("footer", null, footer) : null);
  }
});
export default wireValue(Form);